import { useState, useCallback } from 'react'
import { 
  startAgoraSessionRecording,
  stopAgoraSessionRecording,
  queryAgoraSessionRecordingStatus 
} from 'src/consumer/services/featureServices'

export const useSessionRecording = () => {
  const [isSessionRecording, setIsSessionRecording] = useState(false)
  const [isRecordingProcessWaiting, setIsRecordingProcessWaiting] = useState(false)

  const queryRecordingStatus = useCallback(async (uidObject) => {
    if (isSessionRecording) {
      const response = await queryAgoraSessionRecordingStatus(
        uidObject?.recordingResourceId,
        uidObject?.recordingSid,
      )
      if (response?.status !== 200) {
        setIsSessionRecording(false)
      }
    }
  }, [isSessionRecording])

  const handleRecordingButtonClick = useCallback(async (bookedEventFinalData, uidObject, setUidObject) => {
    setIsRecordingProcessWaiting(true)
    
    if (!isSessionRecording) {
      const response = await startAgoraSessionRecording(
        bookedEventFinalData?.id,
        uidObject?.uidRecording,
      )
      console.log(response)
      
      if (response?.status === 200) {
        setUidObject((prev) => ({
          ...prev,
          recordingResourceId: response?.data?.resourceId,
          recordingSid: response?.data?.sid,
        }))
        
        await queryAgoraSessionRecordingStatus(response?.data?.resourceId, response?.data?.sid)
        setIsSessionRecording(true)
      }
    } else {
      const response = await stopAgoraSessionRecording(
        bookedEventFinalData?.id,
        uidObject?.uidRecording,
        uidObject?.recordingResourceId,
        uidObject?.recordingSid,
      )
      console.log(response)
      setIsSessionRecording(false)
    }
    
    setIsRecordingProcessWaiting(false)
  }, [isSessionRecording, queryRecordingStatus])

  return {
    isSessionRecording,
    setIsSessionRecording,
    isRecordingProcessWaiting,
    setIsRecordingProcessWaiting,
    queryRecordingStatus,
    handleRecordingButtonClick,
  }
}